export default Object.freeze(
  {
    "CREATE": 0,
    "UPDATE": 1,
    "DELETE": 2
  }
);
